import { IDs } from '../../../helpers/IDs';
import { getCO2AequivalentSubscope1 } from '../getCO2Aequivalent';
import { TempLog } from '../../TempLog';
import { setTempLog } from '../tempLog';
import { Kennzahl, getKennzahl } from '../strukturiert/Kennzahl';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';
import { makeSimpleKennzahl } from '../strukturiert/makeKennzahl';

export function processSubscope1(row: any, data: any, item: any, jahr: number) {
    row = {...row};
    // console.log('SS1 - IN: ', jahr, row, data);
    // Konfig
    const konfData: Array<any> = data[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;
    // console.log('9.1', row.name, row.faktor, row);

    // Wir müssen uns erst den Namen des Materials holen
    const arr_mat = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL];
    const mat = arr_mat.find((m: any) => (row.art_tid_orig || row.art_tid) === m.tid);
    if ((!mat || !mat.name) && modus !== 'supplier_specific' && modus !== 'user_specific') {
       // console.log('NO MAT', row, arr_mat);
        return;
    }
    // Faktor bestimmen
    let faktor_wert = 0;
    let faktor_name = '';
    let faktor_quelle = '';
    let faktor_multiplier = 1000;
    let faktor_datenqualiaet = '';
    let einheit = 't';
    let einheit_user = row.einheit || 'kg';
    if (modus && co2_fussabdruck_ghg && (modus === 'supplier_specific' || modus === 'user_specific')) {
        faktor_wert = row.faktor;
        faktor_name = row.name ? row.name : row.art_tid;
        faktor_quelle = `Eingabe durch Nutzer:in${row.quelle ? ` / Quelle: ${row.quelle}` : ''}`;
        einheit = row.einheit;
        einheit_user = row.einheit;
        faktor_multiplier = 1000;
    } else {
        if ((co2_fussabdruck_ghg && (!modus || modus === 'average_data')) || (!co2_fussabdruck_ghg && einheit_user === 'kg')) {
            if ( einheit_user === 'm3') {
                einheit = 'm3';
                faktor_multiplier = 1;
            } else
            if ( einheit_user === 'l') {
                einheit = 'm3';
                faktor_multiplier = 1000;
            } else
            if ( einheit_user === 't') {
                einheit = 't';
                faktor_multiplier = 1;
            } else
            if ( einheit_user === 'kg') {
                einheit = 't';
                faktor_multiplier = 1000;
            } else
            if ( einheit_user === 'stk') {
                einheit = 'stk';
                faktor_multiplier = 1;
            }
        } else
        if (modus === 'spend_based'  || (!co2_fussabdruck_ghg && einheit_user === 'euro')) {
            einheit = 'euro';
            einheit_user = '€';
            faktor_multiplier = 1;
        }
        // if (!mat && modus !== 'supplier_specific' && modus === 'user_specific') {
        if (!mat || !mat.name) {
            if (row.art_tid_orig || row.art_tid) {
                setTempLog({ name: 'Subscope 1', description: 'Material fehlt'});
            }
            return;
        }
        const faktor = getCO2AequivalentSubscope1(data, jahr, mat.name, einheit);
        // console.log('S3 1 Faktor...', faktor);
        faktor_wert = faktor.wert;
        faktor_name = faktor.name;
        faktor_quelle = faktor.quelle;
        faktor_datenqualiaet = faktor.datenqualitaet;
    }

    const value = faktor_wert * (row.menge / faktor_multiplier);
    const key_wert = 'co2_fussabdruck_s3_ss1_wert';
    const key_items = 'co2_fussabdruck_s3_ss1_items';
    if (!item[key_items]) {
        item[key_items] = [];
    }
    if (faktor_name === 'Dienstleistungen') {
        return;
    }
    // console.log('SS1 - PROC: ', jahr, value, faktor_name, faktor_wert, row);
    row.value = value;
    row.name = faktor_name;
    row.faktor = faktor_wert * (1000000 / faktor_multiplier);
    row.einheit = einheit_user;
    row.faktor_einheit = 'gCO₂Äq/' + einheit_user;
    row.quelle = faktor_quelle;
    row.datenqualitaet_emissionsfaktor = ['supplier_specific', 'user_specific'].indexOf(modus) !== -1
        ?  row.datenqualitaet_emissionsfaktor
        : faktor_datenqualiaet;
    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + value;
    // console.log('SS1 - IN: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
    if (!isNaN(value)) {
        item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + value;
        item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + value;
    }
    // console.log('SS1 - OUT: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);

    // Kennzahl erstellen
    makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss1_' + row.tid, jahr, row.standort_tid_orig, row.tid,
                        'Menge', row.name, row.menge, row.value, row.einheit,
                        row.faktor, faktor_quelle, data, row.faktor_einheit);
}

